import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectQRCode = createSelector(
  [(store: RootState) => store.qrScanner.qrCode],
  (data) => data
);